import { EntityId } from "@reduxjs/toolkit";
import React from "react";
import { useAppSelector } from "../../../../app/hooks";
import { Category } from "../../../category/types/types";
import { selectedProject } from "../../../home/appSlice/appslice";
import { SubCategory } from "../../../subcategory/types/types";
import { useGetExperienceHotspotSublistQuery } from "../../api/experienceCardApiSlice";
import ExperienceHotSpotSubListPresentation from "../../presentation/experienceHotSpotSubListPresentation/ExperienceHotSpotSubListPresentation";
type ExprienceHotSpotSubListProp = {
  hotspotgroupid: string;
  category: Partial<Category> | null;
  subCategory: Partial<SubCategory> | null;
  expPublish: boolean;
  expSave: boolean;
  term: string;
  onEdit: (id: EntityId) => void;
  onReview: (id: EntityId) => void;
};
const ExperienceHotSpotSubList: React.FC<ExprienceHotSpotSubListProp> = ({
  hotspotgroupid,
  category,
  subCategory,
  expPublish,
  expSave,
  term,
  onEdit,
  onReview
}) => {
  const project = useAppSelector(selectedProject);
  

  const { data,  isSuccess } =
    useGetExperienceHotspotSublistQuery({
      hotspotgroupid,
      project: project!._id!,
      category: category?._id!,
      subCategory: subCategory?._id,
      expPublish,
      expSave,
      term
    })
  return (
    <>
      {isSuccess && (
        <>
            <tr>
            <td colSpan={12} style={{width: '100%'}}>
        <table style={{position:'relative', left:50, width: 'calc(100% - 50px)' ,    borderCollapse: 'separate',
    borderSpacing: '0 10px'}}>
          <tbody>
        {data.ids.map((id) => (
            <ExperienceHotSpotSubListPresentation
              key={id}
              item={data.entities[id]!}
              onEdit={onEdit}
              onReview={onReview}
            />
          ))}
        </tbody></table>

        </td>
        </tr>

        </>
      )}
    </>
  )
}

export default ExperienceHotSpotSubList
